var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCallOutgoing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 9.30111C10.5333 9.30111 9.66667 9.16777 8.93333 8.90111H8.73333C8.53333 8.90111 8.4 8.96777 8.26667 9.10111L6.8 10.5678C4.93333 9.56777 3.33333 8.03444 2.4 6.16777L3.86667 4.70111C4.06667 4.50111 4.13333 4.23444 4 4.03444C3.8 3.30111 3.66667 2.43444 3.66667 1.63444C3.66667 1.30111 3.33333 0.967773 3 0.967773H0.666667C0.333333 0.967773 0 1.30111 0 1.63444C0 7.90111 5.06667 12.9678 11.3333 12.9678C11.6667 12.9678 12 12.6344 12 12.3011V9.96777C12 9.63444 11.6667 9.30111 11.3333 9.30111ZM1.33333 2.30111H2.33333C2.4 2.90111 2.53333 3.50111 2.66667 4.03444L1.86667 4.83444C1.6 4.03444 1.4 3.16777 1.33333 2.30111ZM10.6667 11.6344C9.8 11.5678 8.93333 11.3678 8.13333 11.1011L8.93333 10.3011C9.46667 10.4344 10.0667 10.5678 10.6667 10.5678V11.6344ZM8 0.967773V1.96777H10.3333L6.66667 5.63444L7.33333 6.30111L11 2.63444V4.96777H12V0.967773H8Z",
    fill: "#1677FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCallOutgoing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/call-outgoing.3f6cfc5161803228303bfecadc0e5801.svg";